import {i18n} from "../../shared/i18n";
const LEVEL_NAMES = Array.from({length: 7}, (_, index) => `level${index + 1}`);
const DECIMAL_PATTERN = /^\d+(?:[.,]\d+)?$/;
const POSITIVE_INTEGER_PATTERN = /^[1-9]\d*$/;
const REF_CODE_PATTERN = /^[A-Z0-9]+$/;

const asString = (value, fallback = "") => (
    value === null || value === undefined || value === "" ? fallback : String(value)
);

export const normalizeCredentialDraft = (response = {}) => Object.fromEntries(
    LEVEL_NAMES.map((name) => [name, asString(response?.levels?.[name], "0")]),
);

export const validateCredentialDraft = (draft = {}) => {
    const values = {};
    for (const [index, name] of LEVEL_NAMES.entries()) {
        const raw = asString(draft[name]).trim().replace(/,/g, ".");
        if (!DECIMAL_PATTERN.test(raw)) {
            return {values: null, error: i18n.t("sections.referrals.p115", {v0: index + 1})};
        }
        values[name] = raw;
    }
    return {values, error: ""};
};

export const validateRefCode = (value) => {
    const normalized = asString(value).trim();
    if (!normalized) return {value: "", error: i18n.t("sections.referrals.p116")};
    if (normalized.length > 8 || !REF_CODE_PATTERN.test(normalized)) {
        return {
            value: normalized,
            error: i18n.t("sections.referrals.p117"),
        };
    }
    return {value: normalized, error: ""};
};

export const validateFillDraft = ({phoneNumber, amount}) => {
    const phone = asString(phoneNumber).trim();
    const sum = asString(amount).trim();
    if (!phone) return {values: null, error: i18n.t("sections.referrals.p36")};
    if (!POSITIVE_INTEGER_PATTERN.test(sum)) {
        return {values: null, error: i18n.t("sections.referrals.p118")};
    }
    return {values: {phone_number: phone, ref_sum: sum}, error: ""};
};

export const validateMoveDraft = ({userId, refType, search}) => {
    const id = asString(userId).trim();
    const target = asString(search).trim();
    if (!/^[1-9]\d*$/.test(id)) return {values: null, error: i18n.t("sections.referrals.p119")};
    if (!["place", "user"].includes(refType)) return {values: null, error: i18n.t("sections.referrals.p120")};
    if (!target) {
        return {
            values: null,
            error: refType === "user" ? i18n.t("sections.referrals.p121") : i18n.t("sections.referrals.p122"),
        };
    }
    return {values: {user_id: id, ref_type: refType, search: target}, error: ""};
};

export const flattenReferralNetwork = (node, level = 0, rows = []) => {
    if (!node || typeof node !== "object") return rows;
    const details = node.user_details || {};
    if (details.user_id !== null && details.user_id !== undefined) {
        rows.push({
            id: String(details.user_id),
            name: details.name || details.phone_number || `#${details.user_id}`,
            phone: details.phone_number || "",
            level,
        });
    }
    const children = Array.isArray(node.invited_users) ? node.invited_users : [];
    children.forEach((child) => flattenReferralNetwork(child, level + 1, rows));
    return rows;
};

export const normalizePlaceHistory = (response = {}) => ({
    balance: asString(response.ref_sum, "0"),
    invitedCount: Number(response.invited_sum || 0),
    networkCount: Number(response.ref_invited_sum || 0),
    items: (Array.isArray(response.items) ? response.items : []).map((item) => ({
        type: item.history_type || "—",
        date: item.created_at || "—",
        amount: asString(item.sum, "0"),
        user: item.user || "—",
    })),
});

export const pageFromReferralLink = (link) => {
    if (!link) return null;
    try {
        const value = Number(new URL(link, "https://referrals.invalid").searchParams.get("page"));
        return Number.isInteger(value) && value > 0 ? value : null;
    } catch (_error) {
        return null;
    }
};
